import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { useMachine } from "@xstate/react";
import HighlightsModal from "./HighlightsModal";
import insightMachine from "../machines/insightMachine";

import icon1_u from "../assets/img/progress/spatial-repetition-stage-1-unread.png";
import icon1_c from "../assets/img/progress/spatial-repetition-stage-1.png";
import icon2_u from "../assets/img/progress/spatial-repetition-stage-2-unread.png";
import icon2_p from "../assets/img/progress/spatial-repetition-stage-2-paused.png";
import icon2_c from "../assets/img/progress/spatial-repetition-stage-2.png";
import icon3_u from "../assets/img/progress/spatial-repetition-stage-3-unread.png";
import icon3_p from "../assets/img/progress/spatial-repetition-stage-3-paused.png";
import icon3_c from "../assets/img/progress/spatial-repetition-stage-3.png";
import tick_icon from "../assets/img/icons/spatial-repetition-check.png";
import { updateInsight, getPageContent } from "../firebase/firebase.utils";
import { formatDate } from "../functions/misc";
import Button from "./Button";

import { RotateClockwise2 } from "tabler-icons-react";

const InsightCycle = ({ insightId, insight,  currentUser, refreshList, setIsCycleModal , autoFirstTick = null }) => {
  const [isHelpModal, setIsHelpModal] = useState(false);
  const [viewCongratulations, setViewCongratulations] = useState(true);
  const [state, send] = useMachine(
    insightMachine.withContext({
      insightId,
      insight,
      currentUser,
      readDate: insight.readDate,
      reviewSchedule: insight.reviewSchedule,
      reviewDate: insight.readDate,
      finalReviewSchedule: insight.readDate,
      finalReviewDate: insight.readDate
    })
  );
  const [cycleContent, setSubText] = useState(null);

  useEffect(() => {
    (async () => {
      const pageData = await getPageContent('cycle');
      if(pageData) {
        var content = JSON.parse(pageData.content);
        setSubText(content['subtext'] ? content['subtext'] : null);
      }
    })();
    
  }, [state.context]);

  useEffect(() => {
    if(autoFirstTick != undefined) {
      firstTick();
    }
  }, [autoFirstTick]);

  const resetInsightCycle = async () => {
    try {
      await updateInsight( insightId, {
        ...insight,
        readDate: null,
        reviewSchedule: null,
        reviewDate: null,
        finalReviewDate: null,
        finalReviewSchedule: null,
      });
      await refreshList();
      send("RESET");
    } catch (err) {}
  };

  const firstTick = async () => {
    try {
      const readDate = insight.readDate ? insight.readDate: new Date();
      const reviewSchedule = new Date(
        new Date(readDate).setDate(readDate.getDate() + 14)
      );

      const chedule = new Date(
        new Date(readDate).setDate(readDate.getDate() + 28)
      );

      await updateInsight( insightId, {
        ...insight,
        readDate,
        reviewSchedule,
      });
      await refreshList();
      send("TICK", { readDate, reviewSchedule });
    } catch (err) {}
  };

  const secondTick = async () => {
    try {
      const reviewDate = new Date();
      const finalReviewSchedule = new Date(
        new Date().setDate(new Date().getDate() + 14)
      );

      await updateInsight(insightId, {
        ...insight,
        reviewDate,
        finalReviewSchedule,
      });
      await refreshList();
      send("TICK", { reviewDate, finalReviewSchedule });
    } catch (err) {}
  };

  const finalTick = async () => {
    try {
      const finalReviewDate = new Date();

      await updateInsight(insightId, {
        ...insight,
        finalReviewDate,
      });
      await refreshList();
      send("TICK", { finalReviewDate });
    } catch (err) {}
  };
  return (
    <>
      <CycleContainer>
        <Header>
          <span>Growth Cycle</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <RotateClockwise2
              title={"Reset"}
              style={{ cursor: "pointer", marginRight: "8px" }}
              onClick={async () => await resetInsightCycle()}
            />
            <HelpButton onClick={() => setIsCycleModal(true)}>?</HelpButton>
          </div>
        </Header>
        {/* Cycle not started yet */}
        {state.matches("readyForFirstTick") && (
          <InsightContainer>
            <span class="text-muted">1x</span>
            <InsightText stage={1} message={<span>Activated on...</span>} />
            <input type="checkbox" onClick={async () => await firstTick()} />
            <span class="text-muted">2x</span>
            <InsightText
              stage={2}
              message={<span>Complete Stage 1 first</span>}
            />
            <span></span>
            <span class="text-muted">3x</span>
            <InsightText
              stage={3}
              message={<span>Complete Stage 2 first</span>}
            />
            <span></span>
          </InsightContainer>
        )}
        {/* Cycle started */}
        {(state.matches("notReadyForSecondTick") ||
          state.matches("readyForSecondTick")) && (
          <InsightContainer>
            <span class="text-muted">1x</span>
            <InsightText
              stage={1}
              message={
                <span>
                  Activated on <strong>{formatDate(state.context.readDate != undefined ? state.context.readDate : new Date())}</strong>
                </span>
              }
            />
            <Tick />
            <span class="text-muted">2x</span>
            <InsightText
              stage={2}
              message={
                state.matches("readyForSecondTick") ? (
                  <span>Ready to review!</span>
                ) : (
                  <span>
                    Review on{" "}
                    <strong>{formatDate(  state.context.reviewSchedule != undefined ? state.context.reviewSchedule : new Date(new Date(state.context.readDate).setDate(new Date(state.context.readDate).getDate() + 14)) )}</strong>
                  </span>
                )
              }
            />
            {state.matches("readyForSecondTick") ? (
              <input type="checkbox" onClick={async () => await secondTick()} />
            ) : (
              <span></span>
            )}
            <span class="text-muted">3x</span>
            <InsightText
              stage={3}
              message={<span>Complete Stage 2 First</span>}
            />
            <span></span>
          </InsightContainer>
        )}
        {(state.matches("notReadyForThirdTick") ||
          state.matches("readyForThirdTick")) && (
          <InsightContainer>
            <span class="text-muted">1x</span>
            <InsightText
              stage={1}
              message={
                <span>
                  Activated on <strong>{formatDate(state.context.readDate)}</strong>
                </span>
              }
            />
            <Tick />
            <span class="text-muted">2x</span>
            <InsightText
              stage={2}
              message={
                <span>
                  Reviewed on{" "}
                  <strong>{formatDate(state.context.reviewDate != undefined ? state.context.reviewDate : new Date(new Date(state.context.readDate).setDate(new Date(state.context.readDate).getDate() + 14)) )}</strong>
                </span>
              }
            />
            <Tick />
            <span class="text-muted">3x</span>
            <InsightText
              stage={3}
              message={
                state.matches("readyForThirdTick") ? (
                  <span>Ready to review!</span>
                ) : (
                  <span>
                    Review on{" "}
                    <strong>
                      {formatDate(state.context.finalReviewSchedule != undefined ? state.context.finalReviewSchedule : new Date(new Date(state.context.readDate).setDate(new Date(state.context.readDate).getDate() + 28)) )}
                    </strong>
                  </span>
                )
              }
            />
            {state.matches("readyForThirdTick") ? (
              <input type="checkbox" onClick={async () => await finalTick()} />
            ) : (
              <span></span>
            )}
          </InsightContainer>
        )}
        {state.matches("completed") && (
          <>
            {viewCongratulations ? (
              <div
                style={{
                  padding: "4rem",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {<InsightIndicator stage={"3C"} />}
                <span
                  style={{
                    color: "var(--color-primary)",
                    fontWeight: "700",
                    marginBottom: "0.5rem",
                    marginTop: "0.5rem",
                    textAlign: "center",
                  }}
                >
                  Congratulations!
                </span>
                <span
                  style={{
                    marginBottom: "0.5rem",

                    textAlign: "center",
                  }}
                >
                  You have completed all the stages for this insight
                </span>
                <Button
                  secondary
                  label={"View history"}
                  onClick={() => setViewCongratulations((v) => !v)}
                />
              </div>
            ) : (
              <InsightContainer>
                <span class="text-muted">1x</span>
                <InsightText
                  stage={1}
                  message={
                    <span>
                      Activated on{" "}
                      <strong>{formatDate(state.context.readDate)}</strong>
                    </span>
                  }
                />
                <Tick />
                <span class="text-muted">2x</span>
                <InsightText
                  stage={2}
                  message={
                    <span>
                      Activated on{" "}
                      <strong>
                        {formatDate(state.context.reviewDate != undefined ? state.context.reviewDate : new Date(new Date(state.context.readDate).setDate(new Date(state.context.readDate).getDate() + 14)) )}
                      </strong>

                    </span>
                  }
                />
                <Tick />
                <span class="text-muted">3x</span>
                <InsightText
                  stage={1}
                  message={
                    <span>
                      Activate on{" "}
                      <strong>
                        {formatDate(state.context.finalReviewDate != undefined ? state.context.finalReviewDate : new Date(new Date(state.context.readDate).setDate(new Date(state.context.readDate).getDate() + 14)) )}
                      </strong>
                    </span>
                  }
                />
                <Tick />
              </InsightContainer>
            )}
          </>
        )}
      </CycleContainer>
      {isHelpModal && (
        <HighlightsModal
          highlights={ cycleContent }
          title={"Growth Cycle"}
          isOpen={isHelpModal}
          setIsOpen={setIsHelpModal}
        />
      )}
    </>
  );
};

export default InsightCycle;

const InsightImage = styled.img`
  width: 100%;
  padding: 12px;
  ${(props) => props.bw && "filter: grayscale(100%);"}
`;

const InsightText = ({ stage, message }) => {
  return (
    <InsightTextContainer>
      <span>Stage {stage}</span>
      {message}
    </InsightTextContainer>
  );
};

const InsightTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px;
  > span:first-child {
    font-size: 11px;
    color: gray;
  }

  > span:nth-child(2) {
    font-size: 13px;
  }
`;

const InsightContainer = styled.div`
  display: grid;
  grid-template-columns: 20% 60% 20%;
  place-items: center;
`;

const Tick = styled.div`
  width: 16px;
  height: 16px;
  background: url(${tick_icon}) no-repeat center;
  background-size: contain;
`;

const HelpButton = styled.div`
  width: 20px;
  height: 20px;
  color: white;
  font-weight: 700;
  border-radius: 100%;
  cursor: pointer;
  background-color: var(--color-primary);
  display: grid;
  place-items: center;
`;

const CycleContainer = styled.div`
  border-radius: 6px;
  border: 1px solid #dedede;
  max-width: 330px;
`;

const Header = styled.div`
  border-bottom: 2px solid #dedede;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  align-items: center;
  > span:first-child {
    font-size: 18px;
    font-weight: 700;
    color: var(--color-text-default);
  }
`;

const Stages = styled.div`
  display: flex;
  flex-direction: column;

  padding: 1rem 1rem;
  > div {
    display: flex;
    justify-content: space-between;
    place-items: center;
    margin-bottom: 1rem;
    margin-top: 1rem;
    > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      > span:first-child {
        font-size: 10px;
        color: #979797;
      }
      > span:nth-child(2) {
        font-size: 14px;
        color: #979797;
      }
    }
  }
`;

export const InsightIndicator = ({ stage, gray, cycle }) => {
  return (
    <IndicatorImage
      src={
        {
          "1U": icon1_u,
          "1C": icon1_c,
          "2U": icon2_u,
          "2P": icon2_p,
          "2C": icon2_c,
          "3U": icon3_u,
          "3P": icon3_p,
          "3C": icon3_c,
        }[stage]
      }
      alt="progress icon"
      gray={gray}
    />
  );
};

const IndicatorImage = styled.img`
  height: ${(p) => (p.cycle ? "50px" : "46px")};
  ${(p) => (p.gray ? "filter: grayscale(100%);" : null)}
`;
